import { STATUS_STYLES, type WorkflowStatus } from "@/lib/design-tokens";
import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: WorkflowStatus;
  showDot?: boolean;
  className?: string;
}

export function StatusBadge({ status, showDot = true, className }: StatusBadgeProps) {
  const styles = STATUS_STYLES[status];

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        styles.bg,
        styles.text,
        styles.border,
        className,
      )}
    >
      {showDot ? (
        <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", styles.dot)} />
      ) : null}
      {status}
    </span>
  );
}
